import React, { useEffect, useState } from "react";
import { Footer } from "../../../components/LandingPage/footer";
import businessDivisions from "../../../data/businessDivision";
import Banner from "./components/Banner";
import Timeline from "./components/Timeline";
import Infos from "./components/Infos";
import Products from "./components/Products";
import { useTranslation } from "next-i18next";
import styles from "./business-division.module.scss";
import { useRouter } from "next/router";
import useSelectedLanguageCode from "../../../hooks/useSelectedLanguageCode";
import {
	getI18nPaths,
	getI18nProps,
} from "../../../lib/next-i18next/getStatic";
import Head from "next/head";
import { Contact } from "../../../components/LandingPage/Contact";
import { FaceLiftGlobalStyle } from "../../../styles/theme";
import { TopbarLanding } from "../../../components/LandingPage/topbar";

const BusinessDivision = ({ businessDivision }) => {
	const { t } = useTranslation();
	const router = useRouter();
	const selectedLanguageCode = useSelectedLanguageCode();
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	return (
		<div className={styles.businessDivisionPage}>
			<Head>
				<title>Verzel - {t(`businessDivision.${businessDivision?.id}`)}</title>
				<meta
					name="title"
					content={`Verzel - ${t(`businessDivision.${businessDivision?.id}`)}`}
				/>
				<meta
					name="description"
					content={t(`businessDivision.${businessDivision?.id}Text`)}
				/>
			</Head>

			<TopbarLanding />
			{businessDivision && (
				<>
					<Banner
						bannerText={businessDivision.bannerText[selectedLanguageCode]}
						divisionName={t(`businessDivision.${businessDivision.id}`)}
						id={businessDivision.id}
					/>
					<Timeline
						divisionName={t(`businessDivision.${businessDivision.id}`)}
						divisionDescription={t(
							`businessDivision.${businessDivision.id}Description`,
						)}
						divisionDescription2={t(
							`businessDivision.${businessDivision.id}Description2`,
						)}
						id={businessDivision.id}
					/>
					<Infos
						infos={businessDivision.infos}
						selectedLanguage={selectedLanguageCode}
						id={businessDivision.id}
					/>
					<Products
						products={businessDivision.products}
						selectedLanguage={selectedLanguageCode}
						id={businessDivision.id}
					/>
				</>
			)}
			<FaceLiftGlobalStyle />
			{mounted && <Contact />}
			<Footer />
		</div>
	);
};

export async function getStaticProps(ctx) {
	const i18nProps = await getI18nProps(ctx);

	return {
		props: {
			...i18nProps,
			division: ctx?.params.slug,
			businessDivision:
				businessDivisions.find((bd) => bd.id === ctx?.params.slug) || null,
		},
	};
}

export async function getStaticPaths() {
	const businessDivisionPaths = businessDivisions.map((bd) => ({
		slug: `${bd.id}`,
	}));
	const businessDivisionPathsWithLocale = getI18nPaths(businessDivisionPaths);

	return {
		paths: businessDivisionPathsWithLocale,
		fallback: false,
	};
}

export default BusinessDivision;
